/**
 * @file
 * Block list JS.
*/
(function ($, Drupal, drupalSettings) {

  'use strict';

  // Globally available variables/settings
  Drupal.blockCarousel = function() {
    var $slider = jQuery('.paragraph-field--links .field--name-field-paragraph-links');
    if (window.innerWidth < 992 && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: true,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
      }).addClass('slick');
    } else if (window.innerWidth > 993 && $slider.hasClass('slick-initialized')) {
      $slider.slick('unslick').removeClass('slick');
    }
  }

  /**
   * Convert block list (links) to carousel at mobile.
   */
  Drupal.behaviors.blocksCarousel = {
    attach: function(context, settings) {
      $(once('kinaxisBlockList', '.paragraph-field--links')).each(function() {
        Drupal.blockCarousel();
        $(window).resize(Drupal.blockCarousel);
      });
    }
  }

})(jQuery, Drupal, drupalSettings);